import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M30 90q0-40 70-40t70 40v50q-70 40-140 0Z\"></path><path d=\"M28 52 18 30l32 10zM172 52l10-22-32 10z\"></path><ellipse cx=\"76\" cy=\"92\" fill=\"var(--mc-avatar)\" rx=\"10\" ry=\"14\"></ellipse><ellipse cx=\"124\" cy=\"92\" fill=\"var(--mc-avatar)\" rx=\"10\" ry=\"14\"></ellipse><circle cx=\"76\" cy=\"92\" r=\"4\"></circle><circle cx=\"124\" cy=\"92\" r=\"4\"></circle><path fill=\"none\" stroke=\"var(--mc-avatar)\" stroke-linejoin=\"bevel\" stroke-width=\"4\" d=\"m60 144 10-12 10 12 10-12 10 12 10-12 10 12 10-12 10 12\"></path><circle cx=\"92\" cy=\"128\" r=\"3\" fill=\"var(--mc-avatar)\"></circle><circle cx=\"108\" cy=\"128\" r=\"3\" fill=\"var(--mc-avatar)\"></circle>", 9)
  ]))]))
}
export default { render: render }